module.exports = __webpack_public_path__ + "static/images/close.19bw1EL.svg";